import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Globals} from "./shared/Globals";

@Component({
    template: '',
    standalone: false
})
export abstract class SubscribedComponent implements OnInit, OnDestroy {

  protected subs = [];
  @Input() public readonly loading = new BehaviorSubject<boolean>(false);
  public Globals = Globals;
  public touched: boolean = false;

  ngOnInit(): void {

  }

  public get isDirty(): boolean{
    return false;
  }

  public get isLoading(){
    return this.loading.getValue();
  }

  ngOnDestroy() {
    this.subs.forEach(o => o.unsubscribe());
    this.subs = [];
  }

  public get headerTitle():string|{title:string, translate:boolean|Object}{
    return null;
  }


}
